<template>
  <div class="wrap-content">
    <div class="banner-wrap">
        <div class="banner-item">
            <div class="banner-text-area">
                <div class="container">
                    <div class="banner-headline">
                        <div>초등학생이 <span class="text-secondary font-weight-bolder">1년</span>만에</div>
                        <div><span class="text-secondary font-weight-bolder">미적분</span>을 풀 수 있을까요?</div>
                    </div>
                    <div class="banner-caption">
                        류연우 박사의 수학 교육법을 통해<br/>
                        아이들에게 수학적 사고력을 길러준다면<br/>
                        가능합니다.
                    </div>
                </div>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Banner'
}
</script>

